import { Validators } from '@angular/forms';

export const SEARCH_TEXT_MAX_LENGTH = 255;

export const SEARCH_TEXT_MAX_LENGTH_VALIDATOR = Validators.maxLength(SEARCH_TEXT_MAX_LENGTH);
